import { useEffect } from 'react';

import { useQuery } from '@tanstack/react-query';
import { ChevronUp, ClipboardPen } from 'lucide-react';
import { useShallow } from 'zustand/react/shallow';

import { useBreakpointDown } from '@nesso/ui/hooks/use-breakpoint-down';
import { Button } from '@nesso/ui/primitives/button';

import { sessionsByDayOptions } from '@/entities/session';
import { useSheetStore } from '@/shared/stores/sheet-store';

export function TodaySessionsMobileTrigger() {
    const isMobile = useBreakpointDown();
    const { openSheet, closeCurrentSheet } = useSheetStore(
        useShallow((state) => ({
            openSheet: state.openSheet,
            closeCurrentSheet: state.closeCurrentSheet,
        })),
    );
    const { data } = useQuery(sessionsByDayOptions());
    const count = data?.length ?? 0;

    useEffect(() => {
        const handleChange = () => {
            if (!isMobile) {
                closeCurrentSheet();
            }
        };

        handleChange();
    }, [isMobile, closeCurrentSheet]);

    if (!isMobile) {
        return null;
    }

    return (
        <div className="mt-auto flex justify-center pb-4">
            <Button
                type="button"
                variant="ghost"
                className="text-base"
                onClick={() => openSheet({ type: 'sessions/today', label: "Today's Sessions" })}
                aria-label="Open today's sessions"
            >
                <ClipboardPen className="h-4 w-4" />
                <span>Today’s Sessions ({count})</span>
                <ChevronUp className="h-4 w-4" />
            </Button>
        </div>
    );
}
